import { alpha, Box, Typography } from '@mui/material'
import { styled, withStyles } from '@mui/styles'

export const LegendContainer = styled(Box)(({ theme }) => ({
  zIndex: 1,
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  '&.globalsite': {
    position: 'absolute',
    bottom: 113,
    right: 24,
  }
}))

export const LegendPopper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(3),
  marginRight: theme.spacing(0.5),
  borderRadius: 12,
  backgroundColor: theme.palette.common.white,
  boxShadow: `0 24px 32px -12px ${alpha(theme.palette.common.black, 0.24)}`
}))

export const LegendTitle = withStyles(() => ({
  root: {
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 2,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
  }
}))(Typography)

export const LegendContent = withStyles(() => ({
  root: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: 2,
    whiteSpace: 'nowrap'
  }
}))(Typography)
